import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFreemiumExpiresDate, useFreemiumSubscriptionDays, useIsFreemium } from 'reactApp/hooks/useFreemium';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { FreemiumBannerState, getFreemiumBannerState } from 'reactApp/ui/Freemium/freemiumBanners.helpers';
import { FreemiumEndedBanner } from 'reactApp/ui/FreemiumEndedBanner';
import { FreemiumEndingBanner } from 'reactApp/ui/FreemiumEndingBanner';

export const useFreemiumBanners = () => {
    const isFreemium = useIsFreemium();
    const freemiumDays = useFreemiumSubscriptionDays();
    const freemiumExpiresDate = useFreemiumExpiresDate();
    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);
    const storage = useSelector(getCurrentStorage);
    const { isHome } = getStorage(storage);

    const freemiumBannerState = useMemo(() => {
        if (!isHome || isOverquota) {
            return FreemiumBannerState.NONE;
        }
        const bannerState = getFreemiumBannerState(freemiumDays, freemiumExpiresDate);
        if (bannerState === FreemiumBannerState.ENDED) {
            return FreemiumBannerState.ENDED;
        }
        if (!isFreemium) {
            return FreemiumBannerState.NONE;
        }
        return bannerState;
    }, [isFreemium, freemiumDays, freemiumExpiresDate, isHome, isOverquota]);

    if (freemiumBannerState === FreemiumBannerState.ENDING) {
        return <FreemiumEndingBanner />;
    }

    if (freemiumBannerState === FreemiumBannerState.ENDED) {
        return <FreemiumEndedBanner />;
    }

    return null;
};
